import { defineComponent as _defineComponent } from 'vue'
import {
  PaginatedQuery,
  PartnerReport,
  purposeTypesToHuman,
  Trade,
  ExportListType,
  PartnerTrade,
  TradeStatus,
} from 'ah-api-gateways';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { tradeAndComissionReportTableFields } from 'ah-trades/src/models/tradeTableFields';
import TradeStatusCell from 'ah-trades/src/components/tableCells/TradeStatusCell.vue';
import TradeAndCommissionDetails from 'ah-trades/src/components/info/TradeAndCommissionDetails.vue';
import { capitalize } from 'lodash';
import {
  CommissionDisplayType,
  HedgingInstruments,
  PurposeTypes,
  hedgingInstrumentToHuman,
} from 'ah-api-gateways/models';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { computed, PropType, ref } from 'vue';
import { useTradeState } from '../..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';

interface PartnerReportEmits extends UseManagedListingEmits<PartnerReport> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeReportListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    required: false,
    default: () => ({ tableFields: tradeAndComissionReportTableFields }),
  },
  hidePagination: {
    type: [Boolean, String],
    required: false,
    default: false,
  },
  displayType: {
    type: String as PropType<CommissionDisplayType>,
    required: false,
    default: CommissionDisplayType.ORIGINAL,
  },
  ...defineUseManagedListingProps<PartnerReport>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const tradeState = useTradeState();



const managedListing = useManagedListing<PartnerReport>({
  loadDataRequest(query: PaginatedQuery) {
    return tradeState.services.financial.getPartnerCommissionReportList(query);
  },
  downloadDataRequest(type: string, query: { [key: string]: any }) {
    return tradeState.services.financial.downloadPartnerCommissionReportList(query, type as ExportListType);
  },
  emit,
  props,
  refs: {
    hideDownloadButton: ref(true),
  },
  fields: computed(() => props.config.tableFields),
  reqManager: useRequestManager().manager,
});

const isApportioned = computed(() => {
  return props.displayType === CommissionDisplayType.APPORTIONED;
});

const homeCurrency = computed(() => {
  return managedListing.bindings.data?.list?.find((i) => i.homeCurrency)?.homeCurrency;
});

function getMarkupValue(totalMarkupBasisPoints: number) {
  const out = Math.round(totalMarkupBasisPoints);
  if (!isNaN(out)) {
    return out + 'bp';
  } else {
    return '-';
  }
}

function capitalizeValue(value: string) {
  return capitalize(value);
}

function isTradeRejectedOrCanceled(trade: Trade) {
  return [TradeStatus.REJECTED, TradeStatus.CANCELED].includes(trade.status);
}

// Using a similar approach to the "Row Selected" state to show a left aligned red bar on canceled/rejected trades
// Must use a td as the relative parent for this, and not the tr, due to a bug in Safari CSS
function bodyTrClass(trade: PartnerTrade) {
  if (trade && isTradeRejectedOrCanceled(trade)) {
    return 'rejected-row';
  }

  return '';
}

function purposeType(item: PartnerReport) {
  return purposeTypesToHuman[item.purposeType as PurposeTypes];
}

function hedgingProduct(item: PartnerReport) {
  return hedgingInstrumentToHuman[item.hedgingProduct as HedgingInstruments];
}

expose({ loadData: managedListing.loadData, downloadData: managedListing.listeners.download });

return { __sfc: true,props, tradeState, emit, managedListing, isApportioned, homeCurrency, getMarkupValue, capitalizeValue, isTradeRejectedOrCanceled, bodyTrClass, purposeType, hedgingProduct, TradeStatusCell, TradeAndCommissionDetails, formatCurrencyValue, formatDate }
}

})